<template>
  <div class="bar-chart chart-container">
    <h3 class="bar-chart-title">{{ title }}</h3>
    <v-skeleton-loader v-if="isLoading" type="image"></v-skeleton-loader>
    <div v-if="chartOptions && chartOptions.xAxis && !isLoading">
      <v-chart
        v-if="chartOptions"
        ref="chartInstance"
        @finished="chartFinished"
        :option="chartOptions"
        style="height: 250px; width: 500px;"
      />
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";

import { BarChart } from "echarts/charts";
use([
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  BarChart,
]);

const EMITTED_ACTIONS = {
  FINISHED: "finished",
};

export default {
  name: "VerifiedEventsBarGraph",
  props: {
    title: {
      type: String,
      required: false,
    },
    chartData: {
      type: Object,
      required: true,
    },
    rotation: {
      type: String,
      default: "0",
    },
  },
  computed: {
    chartOptions() {
      return this.constructChartOptions();
    },
    isLoading() {
      return !(this.chartData && this.chartData.seriesData);
    },
  },
  methods: {
    chartFinished() {
      this.$emit(EMITTED_ACTIONS.FINISHED, true);
    },
    reloadChart() {
      if (this.$refs.chartInstance) {
        this.$refs.chartInstance.resize();
      }
    },
    constructChartOptions() {
      if (this.isLoading) {
        return {};
      }

      let option = {
        xAxis: {
          type: "category",
          axisLabel: {
            color: "white",
            interval: 0,
            rotate: parseInt(this.rotation),
            width: 75,
            overflow: "truncate",
          },
          data: this.chartData.xAxis,
        },
        yAxis: {
          axisLabel: {
            color: "white",
          },
          type: "value",
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}",
        },
        legend: {},
        series: [
          {
            type: "bar",
            data: this.getDataAndColor(this.chartData.seriesData),
          },
        ],
      };
      return option;
    },
    getDataAndColor(dataArray) {
      let colorArray = [
        "#432852",
        "#553369",
        "#673E7F",
        "#724389",
        "#57467A",
        "#464E75",
        "#358797",
        "#4792A0",
        "#68B9CB",
        "#8EC2CD",
      ];
      let ret = [];
      for (let i = 0; i < dataArray.length; i++) {
        let data = {};
        data.itemStyle = { color: colorArray[i % 10] };
        data.value = dataArray[i];
        ret.push(data);
      }
      return ret;
    },
  },
  watch: {
    refresh: {
      handler() {
        this.reloadChart();
      },
    },
  },
};
</script>

<style scoped>
.bar-chart {
  color: #fff;
  padding: 0 !important;
}
</style>
